/**
 * A therapy day is not a calendar day: it runs from noon to noon, so that a night of sleep falls
 * into a single day. Lives here rather than with the therapy calendar because the statistics of a
 * day are reported outside of it as well.
 */
export const therapyDayStartHour = 12;
export const hoursInTherapyDay = 24;
export const minutesInTherapyDay = hoursInTherapyDay * 60;
